import React from "react";
import { Link } from "react-router-dom";
import { BedDouble, Users, MapPin } from "lucide-react";
import HouseImagePlaceholder from "./HouseImagePlaceholder";
import { fileUrl } from "../lib/api";
import { formatMoney } from "../lib/auth";

export default function HouseCard({ house }) {
  const cover = (house.photos || []).find((p) => p.is_cover) || (house.photos || [])[0];
  return (
    <Link
      to={`/casas/${house.slug}`}
      data-testid={`house-card-${house.slug}`}
      className="group block bg-white rounded-lg overflow-hidden border border-slate-200 hover:border-[#3B9FD4] hover:shadow-[0_20px_40px_-15px_rgba(26,54,93,0.15)] transition-[border-color,box-shadow] duration-300"
    >
      <div className="relative">
        {cover ? (
          <div className="aspect-[4/3] w-full overflow-hidden bg-slate-100">
            <img
              src={fileUrl(cover.storage_path)}
              alt={house.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>
        ) : (
          <HouseImagePlaceholder />
        )}
        {house.tagline && (
          <div className="absolute top-3 left-3 bg-white/95 backdrop-blur border border-white/40 text-[10px] tracking-[0.22em] uppercase text-[#0AA89C] px-3 py-1 rounded-full">
            {house.city}
          </div>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-display text-xl text-[#22302E]">{house.name}</h3>
        </div>
        {house.tagline && (
          <p className="text-sm text-slate-600 mt-1 line-clamp-1">{house.tagline}</p>
        )}
        <div className="flex flex-wrap items-center gap-4 mt-4 text-xs text-slate-500">
          <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {house.city} / {house.state}</span>
          <span className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" /> até {house.max_guests}</span>
          <span className="flex items-center gap-1.5"><BedDouble className="w-3.5 h-3.5" /> {house.bedrooms} quartos</span>
        </div>
        <div className="mt-5 flex items-baseline justify-between">
          <div>
            <span className="text-[10px] uppercase tracking-[0.24em] text-slate-500 block">A partir de</span>
            <span className="font-display text-2xl text-[#0AA89C]">{formatMoney(house.base_price)}</span>
            <span className="text-xs text-slate-500"> / noite</span>
          </div>
          <span className="text-xs uppercase tracking-[0.24em] text-[#066B63] group-hover:text-[#0AA89C]">Ver detalhes →</span>
        </div>
      </div>
    </Link>
  );
}
